import {ActionTypes as SignActions} from 'store/sign/signConstants';
import {ActionTypes as LoginActions} from 'store/login/loginConstants';
import { translate } from 'utils/translateUtil';

const initialState = {
    actionAfterSuccess: null,
    payloadAfterSuccess:null,
    checkRequestType: 'PUT',
    pending:false,
    success:false,
    hasError:false,
    type:false,
    challengeData: null,
    transactionId: null,
    executeIteration: 0,
    checkPath: null,
    responseCode: 200,
    resetCounter: false,
    buttons: [],
    headlines: {
        success: translate('loginApp.signing-overlay.success.headline'),
        error: translate('loginApp.signing-overlay.failed.headline')
    }
};

const reducer = (state = initialState, action:any) => {
    const payload = action.payload;

    switch (action.type) {
        case SignActions.CHECK_SIGN_PENDING:
            return {
                ...state,
                pending:true,
                responseCode: initialState.responseCode
            }
        case SignActions.CHECK_SIGN_REJECTED:
            const hasError = payload.response.status !== 409 || (!!payload.response.data.transactionId) ? state.transactionId !== payload.response.data.transactionId : false;
            return {
                ...state,
                executeIteration: state.executeIteration + 1,
                hasError,
                pending:false,
                resetCounter: true,
                responseCode: payload.response.status
            }
        case SignActions.CHECK_SIGN_FULFILLED:
            return {
                ...state,
                executeIteration: 0,
                success: true,
                hasError: false,
                pending: false,
                responseCode: 200
            }
        case SignActions.RESET_SIGN:
            return {
                ...initialState
            }

        case LoginActions.FIRST_LOGIN_REJECTED:
                if(payload.response.status === 409) {
                    return {
                        ...initialState,
                        challengeData: payload.response.data.challengeData,
                        type: payload.response.data.choosenDigitalSignatureMethod.methodId,
                        checkPath: 'olb_access_control/first_access/login',
                        checkPayload: {
                            ...payload.loginData
                        },
                        transactionId: payload.response.data.transactionId,
                        checkRequestType: 'POST',
                        resetCounter: true,
                        buttons: {
                            success: [],
                            error: [
                                {
                                    path: '',
                                    title: translate('default.button.textConfirm')
                                }
                            ]
                        }
                    }
                } else {
                    return state;
                }
        case 'UNSET_COUNTER':
            return {
                ...state,
                resetCounter: false
            }
        case LoginActions.START_SECOND_FACTOR:
            return {
                ...initialState,
                challengeData: payload.challengeData,
                type: payload.signMethod,
                checkPath: 'olb_access_control/2fa/transaction',
                checkPayload: {
                    code: payload.code
                },
                transactionId: payload.transactionId,
                checkRequestType: 'POST',
                buttons: {
                    success: [],
                    error: [
                        {
                            path: payload.logoutUrl,
                            title: translate('default.button.textConfirm'),
                            external: true
                        }
                    ]
                }
            }
        default:
            return {
                ...state
            };
    }
};
export default reducer;